
import {Commessa} from '../models/commessa';
import {Statolavorazione} from '../models/statolavorazione';
import {Tipolavorazione} from '../models/tipolavorazione';



export class Lavorazione {
    Codice: number;
    Nome: string;
    Statolavorazione: Statolavorazione;
    Commessa: Commessa;
    Codicecommessa: number;
    Codicestatolavorazione: number;
    Codicetipolavorazione: number;
    Importo: number;
    Sconto: number;
    Subtotale: number;
    Quantita: number;
    Tipolavorazione: Tipolavorazione;
    Nometipolavorazione: string;
    Nomestato: string;

  constructor(){
    this.Codice=0;
    this.Nome='';
    this.Statolavorazione=new Statolavorazione();
    this.Commessa=new Commessa();
    this.Codicecommessa=0;
    this.Codicestatolavorazione=0;
    this.Codicetipolavorazione=0;
    this.Importo=0;
    this.Sconto=0;
    this.Subtotale=0;
    this.Quantita=0;
    this.Tipolavorazione=new Tipolavorazione();
    this.Nometipolavorazione='';  
    this.Nomestato='';
  }
}
